








































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import Util from "../../lib/util";
import moment from "moment";
@Component
export default class Notice extends AbpBase {
    get noticeList(): Array<any> {
        return this.$store.state.notice.list;
    }
    get unReadCount() {
        return this.$store.state.notice.unreadCount;
    }
    get noticeSpinShow() {
        return this.$store.state.notice.loading;
    }
    get noticeCount() {
        return this.noticeList.length;
    }
    get noticeLabel() {
        let name = this.L("Notice");
        if (this.noticeCount > 0) {
            return `${name}(${this.noticeCount})`;
        } else {
            return name;
        }
    }
    getNotices(loadMore: boolean) {
        if (loadMore) {
            this.$store.commit("notice/setLoadMore", loadMore);
        }
        this.$store.dispatch({
            type: "notice/getAll"
        });
    }
    format(userNotification, truncateText) {
        var formatted = {
            userNotificationId: userNotification.id,
            text: Util.abp.notifications.getFormattedMessageFromUserNotification(
                userNotification
            ),
            time: moment(userNotification.notification.creationTime).format(
                "YYYY-MM-DD HH:mm:ss"
            ),
            state: Util.abp.notifications.getUserNotificationStateAsString(
                userNotification.state
            ),
            data: userNotification.notification.data,
            isUnread: userNotification.state === Util.abp.notifications.userNotificationState.UNREAD,
            timeAgo: moment(
                userNotification.notification.creationTime
            ).fromNow()
        };

        if (truncateText || truncateText === undefined) {
            formatted.text = Util.abp.utils.truncateStringWithPostfix(
                formatted.text,
                100
            );
        }

        return formatted;
    }
    created() {
        this.getNotices(false);
    }
}
